import React, { useEffect, useState } from "react";
import Login0 from "./Login0";
import Login1 from "./Login1";
import Login2 from "./Login2";

function Login({ isOpen, onClose }) {
  const logins = { 0: Login0, 1: Login1, 2: Login2 };
  const [loginNo, setLoginNo] = useState(null);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setLoginNo(Number(parsedStyle.signup_layout_no) || 0);
    } else {
      setLoginNo(0); // Default to Login0 if nothing is found
    }
  }, []);

  if (loginNo === null) {
    return null; // Prevent rendering before `loginNo` is set
  }

  const SelectedLogin = logins[loginNo];

  return isOpen ? <SelectedLogin isOpen={isOpen} onClose={onClose} /> : null;
}

export default Login;
